import httpClient from "../http/http-client";
import { IAccreditation, IPostAccreditation } from './accreditations.model';

export default class AccreditationsService {
  http;

  constructor() {
    this.http = httpClient
  }

  async getAll(): Promise<IAccreditation[]> {
    return this.http.get('accreditation')
      .then(response => {
        return response.data.rows
      })
      .catch(err => {
        throw err
      });
  }

  async getAllWithPagination(page: number, perPage: number = 10, orderBy?: string, order?: 'asc' | 'desc'): Promise<{ count: number, rows: IAccreditation[] }> {
    return this.http.get(`accreditation?page=${page}&perPage=${perPage}${order && orderBy ? `&orderBy=${orderBy}&order=${order}` : ''}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        throw err
      });
  }

  async getOne(accreditationId: string): Promise<IAccreditation> {
    return this.http.get(`accreditation/${accreditationId}`)
      .then(response => {
        return response.data
      })
      .catch(err => {
        throw err
      });
  }

  async edit(accreditationId: string, accreditation: IPostAccreditation): Promise<IAccreditation> {
    return this.http.patch(`accreditation/${accreditationId}`, accreditation)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }

  async create(accreditation: IPostAccreditation): Promise<IAccreditation> {
    return this.http.post(`accreditation`, accreditation)
      .then(response => {
        return response.data
      })
      .catch(err => {
        console.log(err);
        throw err;
      });
  }
}
